export const redirectOptions = [
  "CUSTOMER",
  "UNRESOLVED",
  "SUSPICIOUS",
  "SELF_EXCL",
  "AGE",
];
